require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-amcor-site-transformation.json") })
        }
      }, "path---news-amcor-site-transformation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-amcor-site-transformation!./.cache/json/news-amcor-site-transformation.json
// module id = 787
// module chunks = 231608221292675